import "materialize-css";

const ModalContentDirective = function () {
    return {
        restrict: 'E',
        link: function (scope, elm, attr) {
            elm.addClass("modal-content with-header");
        }
    }
};

export { ModalContentDirective };